import { render, staticRenderFns } from "./uploadPartner.vue?vue&type=template&id=498414e0"
import script from "./uploadPartner.vue?vue&type=script&lang=js"
export * from "./uploadPartner.vue?vue&type=script&lang=js"
import style0 from "./uploadPartner.vue?vue&type=style&index=0&id=498414e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports